import {DepositDefaultPaymentType} from '../schemas/depositDefaultPaymentTypeSchema';
import {DepositMethodName} from '../types/DepositMethodName';

/**
 * Order payment type that a deposit method represents when it is picked as the default payment
 * method.
 */
export const DEPOSIT_METHOD_PAYMENT_TYPES: Record<DepositMethodName, DepositDefaultPaymentType> = {
  cashPayment: 'CASH',
  cardPayment: 'CARD',
  bankPayment: 'BANK_TRANSFER',
};
